export class Gtag {
  static pushEvent(event: string, value: string|object, label: string = '') {
    // @ts-ignore
    if (window.dataLayer) {
      // @ts-ignore
      window.dataLayer.push({ event, value, label });
    }
  }

  static pushEventEcommerce(event: string, value: object, label = "") {
    // @ts-ignore
    if (window.dataLayer) {
      // @ts-ignore
      window.dataLayer.push({ event, ecommerce: value, label });
    }
  }

  static clearData() {
    // @ts-ignore
    if (window.dataLayer) {
      // @ts-ignore
      window.dataLayer.push({ value: '', label: '' });
    }
  }
}